import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GroundworksAuthLifecycleService } from '@groundworks/ngx-groundworks-auth';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  template: '<router-outlet></router-outlet>',
  styleUrl: './app.scss'
})
export class AppComponent implements OnInit, OnDestroy {
  protected readonly title = signal('jobs');
  private readonly authLifecycle = inject(GroundworksAuthLifecycleService);

  ngOnInit(): void {
    this.authLifecycle.start();
  }

  ngOnDestroy(): void {
    this.authLifecycle.stop();
  }
}
